const keyUri = {
  // BACKEND_URI: "http://localhost:5000/api",
  // BACKEND_URI: "https://walrus-app-ohvih.ondigitalocean.app/api",
  //new URL
  BACKEND_URI: "https://oyster-app-jc6m9.ondigitalocean.app/api",
};

let token = localStorage.getItem("token");
const config = {
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
};

export { keyUri, config };
